import React, { Component, useState } from "react";
import '../css/index.css';
import HttpService from "../services/HttpService";
import Button from "../Components/PromptOptPagina/Button";
import VeldAlias from "../Components/PromptOptPagina/VeldAlias";

class PromptOptPagina extends Component {
    axios = null;
    state = {
        promptOpt: null,
        output: "",
        editing: false,
        creating: false
    }

    componentDidMount() {
        const httpService = HttpService;
        httpService.configure();
        this.axios = httpService.getAxiosClient();
        if (!window.location.href.endsWith("create")) {
            if (this.props.location.promptOpt !== undefined && this.props.location.promptOpt !== null) {
                this.setState({
                    promptOpt: this.props.location.promptOpt
                });
                return;
            }
        }
        else {
            this.setState({
                editing: true,
                creating: true,
                promptOpt: {
                    emailOntvanger: "",
                    prompt: "",
                    modelName: "Qwen/Qwen3-235B-A22B-Instruct-2507",
                    fieldAliases: []
                }
            });
        }
        const id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (Number.isNaN(Number.parseInt(id))) return;
        this.axios.get(process.env.REACT_APP_INKOFACT_API_URL + "prompt/" + id) // to prevent reloads from breaking the page
            .then(response => { this.setState({ promptOpt: response.data }) })
            .catch(ex => alert(ex));
    }

    TestBtnHandler() {
        this.setState({ output: "Not implemented yet" });
    }

    CreateBtnHandler() {
        if (!this.axios) return;
        var url = process.env.REACT_APP_INKOFACT_API_URL + "prompt/single";
        this.axios.post(url, this.state.promptOpt)
        .then(response => window.location.href = "/PromptOpt/" + response.data)
        .catch(ex => alert(ex));
    }

    EditBtnHandler() {
        if (!this.axios) { alert("axios not yet loaded"); return; }
        if (this.state.editing) {
            var url = process.env.REACT_APP_INKOFACT_API_URL + "prompt";
            this.axios.put(url, this.state.promptOpt)
                .then(response => { window.location.reload() })
                .catch(error => { alert(error); window.location.reload() });
        }
        this.setState({ editing: !this.state.editing });
    }

    AddFieldAliasBtnHandler() {
        if ((this.state.promptOpt === null || this.state.promptOpt === undefined)) return;
        var temp = this.state.promptOpt;
        temp.fieldAliases.push({ promptFieldName: "", mkgFieldName: "" });
        this.setState({ promptOpt: temp });
    }

    DeleteFieldAliasBtnHandler(index) {
        if ((this.state.promptOpt === null || this.state.promptOpt === undefined)) return;
        var temp = this.state.promptOpt;
        temp.fieldAliases = temp.fieldAliases.toSpliced(index, 1);
        this.setState({ promptOpt: temp });
    }

    DeleteHandler() {
        if (!this.axios) { alert("axios not yet loaded"); return; }
        const id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (Number.isNaN(Number.parseInt(id))) return;
        this.axios.delete(process.env.REACT_APP_INKOFACT_API_URL + "prompt/" + id)
            .then(response => window.location.href = "/PromptOpt")
            .catch(ex => alert(ex));
    }

    render() {
        return (
            <div className="relative size-full" data-name="Content Box">
                <div className="flex flex-col items-center max-w-inherit min-w-inherit size-full">
                    <div className="box-border content-stretch flex flex-col items-center max-w-inherit min-w-inherit px-0 py-2 relative size-full">
                        {this.Header()}
                        {this.MappingTableAndTestContentBoxFrame()}
                    </div>
                </div>
            </div>
        );
    }

    Header() {
        return (
            <div className="bg-[#00aaad] relative shrink-0 w-full" data-name="ContentBoxHeader">
                <div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
                <div className="flex flex-col items-center justify-center size-full">
                    <div className="box-border content-stretch flex flex-col items-center justify-center px-[530px] py-[10px] relative w-full">
                        <div className="capitalize flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[20px] text-black text-center tracking-[-0.1px] w-[200px]">
                            <p className="leading-[1.45]">Prompt Optimalisatie</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    EditableField(label, callBack, placeholder) {
        var editableField;
        if (this.state.editing) editableField = (<input onChange={callBack} className="bg-[#ffffff] h-[23px] relative shrink-0 w-[320px] absolute border border-black border-solid inset-0" defaultValue={placeholder} />);
        else editableField = (<input className="bg-[#dedede] h-[23px] relative shrink-0 w-[320px] absolute border border-black border-solid inset-0 pointer-events-none" defaultValue={placeholder} />);

        return (
            <div className="content-stretch flex gap-[7px] items-center relative shrink-0 w-full">
                <label className="w-[140px] text-right font-bold">{label}:</label>
                {editableField}
            </div>
        );
    }

    Fields() {
        var promptOpt = (this.state.promptOpt === null || this.state.promptOpt === undefined) ? { emailVerzender: "", emailOntvanger: "" } : this.state.promptOpt;
        var fieldAliases = (this.state.promptOpt === null || this.state.promptOpt === undefined) ? [] : this.state.promptOpt.fieldAliases;
        return (
            <div className="content-stretch flex flex-col gap-[20px] items-start relative shrink-0 w-full" data-name="Fields">
                {this.EditableField("Verzender", (value) => this.state.promptOpt.emailVerzender = value.target.value, promptOpt.emailVerzender)}
                {this.EditableField("Ontvanger", (value) => this.state.promptOpt.emailOntvanger = value.target.value, promptOpt.emailOntvanger)}
                {this.EditableField("Model", (value) => this.state.promptOpt.modelName = value.target.value, promptOpt.modelName)}
                {this.EditableField("Referentie Regex", (value) => this.state.promptOpt.referenceRegex = value.target.value, promptOpt.referenceRegex)}
                <div>De onderliggende tabel wordt gebruikt om de resultaat velden van de AI om te mappen naar mkg. De velden herkenning is hoofdletter/spatie/onderstreep ongevoelig. Indien deze tabel leeg is betekent dat, dat hij de standard gebruikt die in connectplaza zit.</div>
                <div className="content-stretch flex flex-col gap-[2px] items-end relative shrink-0 w-full" data-name="Fields">
                    <div className="content-stretch flex gap-[7px] items-center relative shrink-0 w-full">
                        <div className="w-full">Ai Veld</div>
                        <div className="px-[10px] w-full">Mkg Veld</div>
                    </div>
                    {fieldAliases.map((fa, index) =>
                        <VeldAlias
                            key={fa.id}
                            index={index}
                            VeldAlias={fa}
                            editing={this.state.editing}
                            onLeftChanged={(val) => this.state.promptOpt.fieldAliases[index].promptFieldName = val}
                            onRightChanged={(val) => this.state.promptOpt.fieldAliases[index].mkgFieldName = val}
                            onDeletePressed={() => this.DeleteFieldAliasBtnHandler(index)}
                        />)}
                </div>
                {!this.state.editing ? "" : <Button
                    text="+"
                    width="30"
                    height="30"
                    onClick={() => this.AddFieldAliasBtnHandler()}
                />}
            </div>
        );
    }

    EditAndCreateButtonFrame() {
        var updateFieldsButtonText = this.state.editing ? "Bevestigen" : "Wijzig";
        var cancelEditButtonElement = this.state.editing ? (<Button text="Annuleren" onClick={() => window.location.reload()} />) : "";
        if ((this.state.creating)) {
            return (
                <div className="flex gap-[30px] w-full" data-name="buttons">
                    <Button text="Create" onClick={() => this.CreateBtnHandler()} />
                </div>
            );
        }
        return (
            <div className="flex gap-[30px] w-full" data-name="buttons">
                <Button text={updateFieldsButtonText} onClick={() => this.EditBtnHandler()} />
                {cancelEditButtonElement}
                <Button text="Delete" onClick={() => this.DeleteHandler()} />
            </div>
        );
    }

    LeftCol() {
        return (
            <div className="box-border gap-[10px] items-start px-[10px] relative shrink-0 flex flex-col">
                {this.Fields()}
                <label className="mt-[30px]">Prompt:</label>
                {this.PromptTextBox()}
            </div>
        );
    }

    TestBoxHeader() {
        return (
            <div className="bg-[#00aaad] relative shrink-0 w-full" data-name="ContentBoxHeader">
                <div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
                <div className="flex flex-col items-center justify-center size-full">
                    <div className="box-border content-stretch flex flex-col items-center justify-center px-[530px] py-[10px] relative w-full">
                        <div className="capitalize flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[20px] text-black text-center tracking-[-0.1px] w-[121px]">
                            <p className="leading-[1.45]">Test</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    PromptTextBox() {
        var prompt = "";
        if (this.state.promptOpt !== null && this.state.promptOpt !== undefined) prompt = this.state.promptOpt.prompt;
        return (
            <div className="bg-white h-grow relative shrink-0 w-full">
                <div className="overflow-clip rounded-[inherit] size-full">
                    <textarea
                        id="inputTextBox"
                        readOnly={!this.state.editing}
                        className="box-border content-stretch flex flex-col h-[400px] items-start p-[5px] relative w-full"
                        defaultValue={prompt}
                        onChange={(value) => this.state.promptOpt.prompt = value.target.value}
                    />
                </div>
                <div aria-hidden="true" className="absolute border border-black border-solid inset-0 pointer-events-none" />
            </div>
        );
    }

    OutputTextBox() {
        return (
            <div className="bg-[#dfdfdf] h-grow relative shrink-0 w-full" data-name="TekstBox">
                <div className="overflow-clip rounded-[inherit] size-full">
                    <textarea readOnly className="box-border content-stretch flex flex-col h-[500px] items-start p-[5px] relative w-full" value={this.state.output}></textarea>
                </div>
                <div aria-hidden="true" className="absolute border border-black border-solid inset-0 pointer-events-none" />
            </div>
        );
    }

    TestContentBoxFrame() {
        return (
            <div className="bg-[rgba(243,244,246,0.75)] relative shrink-0 w-full" data-name="Frame">
                <div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
                <div className="size-full">
                    <div className="box-border content-stretch flex flex-col gap-[10px] items-start p-[20px] relative w-full">
                        {/* <Button onClick={() => this.ExecuteMappingHandler()} text="Execute Mapping" width="100%"/> */}
                        <p className="capitalize font-['Inter:Medium',sans-serif] font-medium leading-[1.45] not-italic relative shrink-0 text-[16px] text-black text-nowrap tracking-[-0.08px] whitespace-pre">Output:</p>
                        {this.OutputTextBox()}
                    </div>
                </div>
            </div>
        );
    }

    ContentBox() {
        var selectedMappingName = "Loading...";
        try { selectedMappingName = this.state.selectedMapping.name; } catch { }
        return (
            <div className="content-stretch flex flex-col items-center justify-center max-w-[2000px] relative shrink-0 w-full" data-name="Content Box">
                {/* <Confirm
                    isOpen={this.state.deleteMenuOpen}
                    title={`Delete Project "${selectedMappingName}"?`}
                    content="WARNING: Dit verwijdert allen mappingen onder dit promptOpt. Mogelijk zijn er Services die gebruik maken van een van deze mappingen."
                    onConfirm={() => this.DeleteHandler()}
                    onCancel={() => this.setState({deleteMenuOpen: false})}
                /> */}
                {/* <div aria-hidden="true" className="absolute border-[3px] border-black border-solid inset-0 pointer-events-none" /> */}
                {/*this.TestBoxHeader()*/}
                {/*this.TestContentBoxFrame()*/}
            </div>
        );
    }

    RightCol() {
        return (
            <div className="basis-0 grow min-h-px min-w-[400px] relative shrink-0" data-name="RightCol">
                <div className="flex flex-col items-center min-w-inherit size-full">
                    <div className="box-border content-stretch flex flex-col gap-[50px] items-center min-w-inherit px-[10px] py-0 relative w-full">
                        {this.EditAndCreateButtonFrame()}
                        {this.ContentBox()}
                    </div>
                </div>
            </div>
        );
    }

    MappingTableAndTestContentBoxFrame() {
        return (
            <div className="bg-[rgba(243,244,246,0.75)] relative shrink-0 w-full" data-name="Frame">
                <div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
                <div className="size-full">
                    <div className="flex gap-[10px] items-start px-[28px] py-[10px] w-full">
                        {/* Make both columns flex-1 for equal width */}
                        <div className="flex-1">
                            {this.LeftCol()}
                        </div>
                        <div className="flex-1">
                            {this.RightCol()}
                        </div>
                    </div>
                </div>
            </div>);
    }

} export default PromptOptPagina